<template>
  <exportTemplate ref="exportTemplate" :formModel="formModel" :table-data="tableList" :summary-data="tableSummaryData" :table-total="paginationTotal" :table-load="tableLoading" :showCustomColumns="false" @pagination-change="paginationChange" @form-submit="formSubmit" @form-reset="formReset" @sort="sortChange" @table-export="tableExport" @emitDblclick="emitDblclick">
    <template #form>
      <el-form-item label="日期范围" prop="billDate.selected">
        <date-picker style="width: 100%;" v-model="formModel.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></date-picker>
      </el-form-item>
      <el-form-item label="订货会" prop="salOrderMeet.selected">
        <select-multiple :select-data="formModel.salOrderMeet"></select-multiple>
      </el-form-item>
      <el-form-item label="客户" prop="customer.selected">
        <el-select class="select_multiple" ref="customerSelectRef" style="width: 100%;" v-model="formModel.customer.selected" value-key="value" multiple clearable placeholder="请选择客户名称" @focus="customerInputFocus">
          <el-option v-for="item in formModel.customer.list" :key="item.value" :label="item.text" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属片区" prop="domainDesc.selected">
        <select-multiple :select-data="formModel.domainDesc"></select-multiple>
      </el-form-item>
      <el-form-item label="客户类型" prop="customerTypes.selected">
        <select-multiple :select-data="formModel.customerTypes"></select-multiple>
      </el-form-item>
      <el-form-item label="业务员" prop="salesman.selected">
        <select-multiple style="width: 100%;" :select-data="formModel.salesman"></select-multiple>
      </el-form-item>
      <el-form-item label="部门" prop="department.selected">
        <select-multiple style="width: 100%;" :select-data="formModel.department"></select-multiple>
      </el-form-item>
      <el-form-item label="商品" prop="product.selected">
        <el-select class="select_multiple" style="width: 100%;" ref="productSelectRef" v-model="formModel.product.selected" value-key="value" multiple clearable placeholder="请选择商品名称" @focus="productInputFocus" @change="productChange">
          <el-option v-for="item in formModel.product.list" :key="item.value" :label="item.text" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="大类" prop="brand.selected">
        <select-multiple :select-data="formModel.brand" :change="brandChange"></select-multiple>
      </el-form-item>
      <el-form-item label="小类" prop="brandType.selected">
        <select-multiple :select-data="formModel.brandType"></select-multiple>
      </el-form-item>
      <el-form-item label="品牌" prop="financialBrand.selected">
        <select-multiple :select-data="formModel.financialBrand"></select-multiple>
      </el-form-item>
    </template>
    <template>
      <el-table-column label="日期" prop="billDateTime" width="150"></el-table-column>
      <el-table-column label="来源单号" prop="sourceBillNoID" width="150"></el-table-column>
      <el-table-column label="类型" prop="billTypeName" width="100"></el-table-column>
      <el-table-column label="客户" prop="customerName" width="150"></el-table-column>
      <el-table-column label="业务" prop="salesmanName" width="150"></el-table-column>
      <el-table-column label="商品" prop="itemName" width="150"></el-table-column>
      <el-table-column label="数量" prop="sumDHDQty" width="110"></el-table-column>
      <el-table-column label="金额" prop="sumDHDAmt" width="110"></el-table-column>
      <el-table-column label="剩余数量" prop="onhandQty" width="110"></el-table-column>
      <el-table-column label="剩余金额" prop="onhandAmt" width="110"></el-table-column>
    </template>
    <el-dialog title="选择客户" width="90%" :visible.sync="dialogCustomerVisible" custom-class="el-dialog-common dialogDomain dialogCustomer" append-to-body destroy-on-close :close-on-click-modal="false" :close-on-press-escape="false">
      <customerSelect v-if="dialogCustomerVisible" @get-customer="getCustomer" :defaultCheckedKeys="formModel.customer.selected"></customerSelect>
    </el-dialog>
    <el-dialog title="选择商品" :visible.sync="selectProductVisible" width="1080px" append-to-body :close-on-click-modal="false" custom-class="product-dialog">
      <selectProduct v-if="selectProductVisible" :args="{ isFitterEnabled: 'N' }" @get-product-data="getProductData" :default-checked-keys="formModel.product.list"></selectProduct>
    </el-dialog>
  </exportTemplate>
  
</template>

<script>
import exportTemplate from '@/components/common/exportTemplate.vue'
import datePicker from '@/components/common/datePicker.vue'
import customerSelect from '@/components/common/customerSelect.vue'
import selectProduct from '@/components/common/selectProduct.vue'
import { pickerOptions, getNowFormatDate, getAddDate, getQueryItem, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
  name: 'mainAccount',
  components: {
    exportTemplate,
    datePicker,
    customerSelect,
    selectProduct
  },
  props: ['options', 'type', 'timestemp'],
  data() {
    return {
      pickerOptions,
      params: {
        page: 1,
        size: 10,
        beginDate: getAddDate(-3),
        endDate: getNowFormatDate()
      },
      formModel: {
        billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
        salOrderMeet: { submitName: 'salOrderMeetID', selected: {}, valueIsObj: true, size: 'mini', isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择订货会', request: { url: '/Account/dataSearchVue/selectOrderMeetForVue.html', type: 'post', params: { page: 1, size: 10, meetType: 'A', orderMeetType: 'A' }, text: '', value: '' }},
        customer: { submitName: 'customerID', selected: [], valueIsObj: true, list: [] },
        financialBrand: { submitName: 'financialBrandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: {page: 1, size: 5, isEnabled: 'Y'}, text: '', value: ''}},
        domainDesc: { submitName: 'domainID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择所属片区', request: { url: '/Account/domainDefine/getDomainListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        salesman: { submitName: 'salesmanID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择业务员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5, isFitterEnabled: 'N' }, text: '', value: '' } },
        department: { submitName: 'departmentID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择部门', request: { url: '/Account/departmentDefine/selectDepartmentDownListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        customerTypes: { submitName: 'classifyID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户类型', request: { url: '/Account/customerTypeDefine/getCustomerTypesForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        brand: { submitName: 'brandID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择大类', request: { url: '/Account/dataSearch/selectBrandListForVue.html', type: 'post', params: {page: 1, size: 5, isPage: 'Y'}, text: '', value: ''}},
        brandType: { submitName: 'itemTypeID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择小类', request: { url: '/Account/dataSearch/selectTypeListNewForVue.html', type: 'post', params: {page: 1, size: 5, isPage: 'Y'}, text: '', value: ''}},
        product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
      },
      paginationTotal: 0,
      tableList: [],
      tableLoading: false,
      tableSummaryData: {},
      dialogCustomerVisible: false,
      promotionCustomerInfo: [],
      selectProductVisible: false
    }
  },
  created() {
  // billDate: this.formModel.billDate.selected,
  //       customer: { text: row.customerName, value: row.customerID },
  //       item: { text: row.itemName, value: row.itemID },
  //       salOrderMeet: { text: row.salOrderMeetName, value: row.salOrderMeetID },
  console.log(this.options)
    let { billDate, item, customer, salOrderMeet } = this.options
    if (billDate) {
      this.formModel.billDate.selected = billDate
    }
    if (customer) {
      this.formModel.customer.selected = [customer]
      this.formModel.customer.list = [customer]
    }
    if (item) {
      this.formModel.product.selected = [item]
      this.formModel.product.list = [item]
    }
    if (salOrderMeet) {
      this.formModel.salOrderMeet.selected = [salOrderMeet]
      this.formModel.salOrderMeet.list = [salOrderMeet]
    }
    this.params = { ...this.params, ...getQueryItem(this.formModel) }
    // this.getTableList()
  },
  mounted() {
        console.log('mounted')
        if(this.type) {
          console.log('上级传参')
        //   window.top.addEventListener('message', this.messageOfSelect)
         this.queryQueryDataTemp()
        } else {
          console.log('页面自身')
          this.getTableList()
        }
    },
  methods: {
    paginationChange({page, size, isGetTable = true}) {
      this.params.page = page
      this.params.size = size
      if (isGetTable) {
        this.getTableList()
      }
    },
    formSubmit() {
      this.params = { ...this.params, ...getQueryItem(this.formModel) }
      this.getTableList()
    },
    formReset() {
      this.params['sortField'] = ''
      this.params['softBy'] = ''
      this.params.page = 1
    },
    productChange(val) {
      this.formModel.product.list = val
    },
    async getTableList() {
      // this.tableList = [{ billType: 1,billNo:2 }]
      this.tableLoading = true
      this.tableData = []
      const { data: res } = await this.$post(
        "/erpnew/account/c/reada46ceb/salOrdermeetItemMaster/selectSalOrderMeetTransList.html",
        this.params
      )
      this.tableLoading = false
      if (res.code != '0') return this.$message.error(res.message)
      let { data, sum, total } = res.data
      this.paginationTotal = total
      this.tableSummaryData = sum
      this.tableList = data
    },
    sortChange({ sortField, sortBy }) {
      this.params['sortField'] = sortField
      this.params['sortBy'] = sortBy
      this.params.page = 1
      this.getTableList()
    },
    tableExport(tabColumn) {
      exportExcelCommonForVue(this.params, tabColumn, '/erpnew/account/c/reada46ceb/salOrdermeetItemMaster/queryTransExcelReport.html')
      console.log(tabColumn)
    },
    getCustomer(row) {
      this.formModel.customer.selected = [...row]
      this.formModel.customer.list = [...row]
      this.dialogCustomerVisible = false
    },
    customerInputFocus () {
      this.$refs['customerSelectRef'].blur()
      this.dialogCustomerVisible = true
    },
    productInputFocus() {
      this.$refs['productSelectRef'].blur()
      this.selectProductVisible = true
    },
    getProductData(data) {
      this.selectProductVisible = false
      this.formModel.product.selected = data
      this.formModel.product.list = data
    },
    brandChange(val) {
      let str = val.map(item => "'" + item.value + "'").join(',')
      this.formModel.brandType.request.params['brandID'] = str
      this.formModel.brandType.isReSearch = true
    },
    emitDblclick(row) {
      console.log(row.billType,row.billNo)
      if(row.billType === 'HCD') {
        row.billType = row.billNo.replace(/[^a-zA-Z]/g,"")
        console.log('HCD修改billtype：' + row.billType)
      }
      let width = window.top.document.browser.availiframeWidth.value
      let height = window.top.document.browser.availiframeHeight.value
      if(row.billType === 'DH') {
        top.addPanel('订还货订单详情', `/yunsierp3/index.html#/enterPage/repayEntry?billType=${ row.billType }&billNo=${ row.billNo }`, width, height, true)
      } else {
        top.addPanel('单据详情', `/yunsierp3/index.html#/docket/docketDetails?billType=${ row.billType }&billNo=${ row.billNo }`, width, height, true)
      }
    },
    queryQueryDataTemp(){
        let tempData = top.getQueryDataTemp(this.timestemp)
        console.log(tempData)
        if(tempData){
            if(tempData.timestemp == this.timestemp)  {
                for( let i in this.formModel ) {
                    Object.keys(tempData).map((key)=>{
                        if(this.formModel[i].submitName === tempData[key].submitName) {
                            this.formModel[i] = tempData[key]
                        }
                    }) 
                }
                console.log(this.formModel )
            }
            this.formSubmit()
        }else {
            this.formSubmit()
        }
    },
    messageOfSelect(e) {
      let { data: res } = e
      console.log(res)
      if(res.tag === 'dataSearchOrderReconciliationTurnover' && res.data.timestemp == this.timestemp)  {
          for( let i in this.formModel ) {
              Object.keys(res.data).map((key)=>{
                  if(this.formModel[i].submitName === res.data[key].submitName) {
                      this.formModel[i] = res.data[key]
                  }
              }) 
          }
          console.log(this.formModel )
      }
      this.formSubmit()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .dialogCustomer {
  height: 90vh;
  display: flex;
  flex-direction: column;
  flex: 1;
  flex-basis: auto;
  box-sizing: border-box;
  min-width: 0;
  .el-dialog__header,
  .el-card__header {
    box-sizing: border-box;
    flex-shrink: 0;
  }
  .el-dialog__body {
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    overflow: auto;
  }
}
</style>